import { render, staticRenderFns } from "./AccordionNavItem.vue?vue&type=template&id=51dd9d1c&scoped=true"
import script from "./AccordionNavItem.js?vue&type=script&lang=js&external"
export * from "./AccordionNavItem.js?vue&type=script&lang=js&external"
import style0 from "./AccordionNavItem.scss?vue&type=style&index=0&id=51dd9d1c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd9d1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Image/Image.vue').default,HotTitle: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
